import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "shared/api/methods";

import * as types from "./types";

export const getMeta = createAsyncThunk(types.GET_META, async () => {
  const data = await api.getMeta();

  return data;
});
